export const updateRequestContants = {
    UPDATE_SUCCESS: "UPDATE_REQUEST_SUCCESS",
    UPDATE_FAILURE: "UPDATE_REQUEST_FAILURE",
};
